import { Box } from "@mui/material";
import { Title } from "./Typography";

export function Card({title, ...props}) {
    return <Box {...props} sx={{borderRadius: 3, border: (theme) => "1px solid " + theme.palette.background.border, padding: 3, backgroundColor: "white", ...props.sx}}>
        {title ? <Title pb={2}>{title}</Title> : null}
        {props.children}
    </Box>
}